import { AdvancedSettingsStoreModule } from "../../../types/AdvancedSettings"

const state = {
  loading: false,
  stripe: {},
  smsProviders: [],
  providerDefaults: {
    Email: "",
    SMS: ""
  }
} as AdvancedSettingsStoreModule

export default state
